import Vue from 'vue'
import Vuex from 'vuex'

import moduleMap from "./modules/moduleMap"
import moduleHome from "./modules/moduleHome"

const moduleRiskEstimate = {
  namespaced: true,
  state: {
    areaRiskEstimateFlag: false,
    airLineEstimateFlag: false,
    airLineAIFlag: false
  }
}

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    moduleMap: moduleMap,
    moduleHome: moduleHome,
    moduleRiskEstimate: moduleRiskEstimate, // 添加这行！
  }
})